import React, { useState } from "react";
import { Link } from "gatsby";
import ArrowRight from '@images/icons/arrowGray.svg';
import ArrowDown from '@images/icons/arrowGrayDown.svg';

const DocsNavigation = ({ navigationContent, activeHeadline, activeTitle, setActiveHeadline, setActiveTitle }) => {
  return (
    <>
      {navigationContent && navigationContent.sort((a, b) => a.node.menuOrder - b.node.menuOrder).map((item) =>
        <React.Fragment key={item.node.title}>
          <Link to={`/docs/${item.node.slug}/`}
            className={`documentation__documentation-wrapper__side-navigation__headline ${activeHeadline.includes(item.node.slug)  || item.search ? 'active' : ''} ${activeHeadline.includes(item.node.slug) ? 'open' : ''}`}
            onClick={() => {
              if (activeHeadline === item.node.slug) {
                setActiveHeadline(item.node.slug)
              } else {
                setActiveHeadline(item.node.slug)
              }
            }}>
            <img src={activeHeadline.includes(item.node.slug) || item.search ? ArrowDown : ArrowRight} alt='logo' loading="lazy" />
            <span>{item.node.title}</span>
          </Link>
          <div className={`documentation__documentation-wrapper__side-navigation__text ${activeHeadline.includes(item.node.slug) || item.search ? 'active' : ''}`}>
            {item.node.children.edges.sort((a, b) => a.node.menuOrder - b.node.menuOrder).map((art, index) =>
              <Link key={index} to={art.node.uri}>
                <span
                  className={`${activeTitle === art.node.title ? 'documentation__documentation-wrapper__side-navigation__text__title active' : 'documentation__documentation-wrapper__side-navigation__text__title'}`}
                  onClick={() => {
                    setActiveTitle(art.node.title)
                    setActiveHeadline(item.node.slug)
                  }}>
                  {art.node.title}
                </span>
              </Link>
            )}
          </div>
        </React.Fragment>
      )}
      <Link to='/docs/faq/' className={`documentation__documentation-wrapper__side-navigation__docs-link ${activeTitle === 'faq' ? `documentation__documentation-wrapper__side-navigation__docs-link_active` : ''}`}>
        <div className='documentation__documentation-wrapper__side-navigation__headline'>
          <span>FAQ</span>
        </div>
      </Link>
    </>
  );
}

export default DocsNavigation;
